import { render, staticRenderFns } from "./SelectColor.vue?vue&type=template&id=a21433a4&"
import script from "./SelectColor.vue?vue&type=script&lang=js&"
export * from "./SelectColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports